import RegisterImage from '@/assets/images/fx/Ofx_register.png';
import FundsImage from '@/assets/images/fx/Ofx_funds.png';
import TransferImage from '@/assets/images/fx/Ofx_track.png';

export const steps = [
  {
    id: 1,
    title: 'Open an account',
    text: 'Complete the registration from in just 5 minutes.',
    icon: RegisterImage,
  },
  {
    id: 2,
    title: 'Transfer funds',
    text: 'Transfer funds to your OFX account.',
    icon: FundsImage,
  },
  {
    id: 3,
    title: 'Track your transfers',
    text: 'Track your transfers and payments.',
    icon: TransferImage,
  },
];
